/**
 * Canonical origin of the web build. Link-preview scrapers (Slack, X, iMessage,
 * Facebook) ignore relative `og:image` paths, so every absolute URL in
 * `src/app/+html.tsx` is built from this one constant — change it here if the
 * deployment moves off the default EAS Hosting subdomain.
 *
 * These tags are baked in at static-export time: editing this file does nothing
 * to an already-built `dist/`. Re-export before re-deploying.
 */
export const SITE_URL = 'https://1-t.expo.app';

export const SITE_NAME = '1-T';
export const SITE_TITLE = '1-T — Can you build a $1T company?';
export const SITE_DESCRIPTION =
  'Draft six legends of tech into six seats and find out what your company is worth. Almost nobody reaches $1T.';

/**
 * Bump the `v` query when the artwork changes: scrapers cache OG images hard and
 * a same-URL replacement can keep serving the old card for days.
 */
export const OG_IMAGE_URL = `${SITE_URL}/og.png?v=1`;

/** True pixel size of `public/og.png` — a 1200×630 card rendered at 2x. */
export const OG_IMAGE_WIDTH = '2400';
export const OG_IMAGE_HEIGHT = '1260';

export const OG_IMAGE_ALT =
  'The 1-T title card: "Can you build a $1T company?" beside a six-seat roster of drafted tech founders.';

/**
 * Contact channels published on /support, /privacy and /terms.
 *
 * The form is the primary one and the only channel known to work — keep the
 * short forms.gle link rather than the expanded docs.google.com URL, so swapping
 * the form out later doesn't mean re-releasing the app. `SUPPORT_EMAIL` must
 * point at a real, monitored mailbox before submitting: store review does check.
 */
export const SUPPORT_FORM_URL = 'https://forms.gle/mFrRE19R9Z3aknw77';
export const SUPPORT_EMAIL = 'support@1-t.app';

/**
 * Stamped on /privacy and /terms. Bump it whenever either page changes in a way
 * a reader would care about — a stale date is worse than none.
 */
export const LEGAL_UPDATED = 'August 14, 2026';
